import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "enclosure-type" }
const _hoisted_2 = ["onClick"]

import { getCurrentInstance } from "vue";
import { IEnclosureType } from "../interface";


export default /*#__PURE__*/_defineComponent({
  props: {
  list: Array as () => IEnclosureType[],
},
  setup(__props) {


const { proxy } = getCurrentInstance() as any;
const openTemplate = (item: IEnclosureType) => {
  proxy.$emit("openTemplate", item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "group",
        key: index,
        onClick: ($event: any) => (openTemplate(item))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(`iconfont ${item.icon}`)
        }, null, 2),
        _createElementVNode("p", null, _toDisplayString(item.text), 1)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})